var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuestionCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 0a12 12 0 1 0 12 12A12.013 12.013 0 0 0 12 0Zm0 19a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 12 19Zm1.6-6.08a1 1 0 0 0-.6.917 1 1 0 1 1-2 0 3 3 0 0 1 1.8-2.75A2 2 0 1 0 10 9.255a1 1 0 1 1-2 0 4 4 0 1 1 5.6 3.666Z"
})));
export { SvgQuestionCircle as ReactComponent };
export default __webpack_public_path__ + "eb00a2b5e803809c3498979a0cfec81c4cc38668a0125801e496fb60456ec7f4.svg";